export const styleModules = (theme) => ({
  inputLegends: {
    "& label.MuiFormLabel-root": {
      backgroundColor: "#fff",
      marginLeft: "-5px",
      marginTop: "-5px",
      padding: "0 6px",
    },
  },
  rootBool: {
    textAlign: "left",
    paddingTop: "26px",
    color: "#555555",
  },
  labelBool: {
    fontWeight: "500 !important",
    fontSize: "14px !important",
  },
  controlRootInput: {
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
  },
  textField: {
    width: "290px",
    height: "44px",
    "& .MuiOutlinedInput-input": {
      background: "none !important",
    },
    "& .MuiInputLabel-formControl": {
      top: "-6px !important",
    },
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
  },
  input: {
    width: "290px",
    height: "44px",
    backgroundColor: "#fff",
    paddingBottom: "3px",
    "&::placeholder": {
      color: "#555555 !important",
    },
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
  },
  rootNumberFormat: {
    paddingTop: "30px",
    "@media (max-width: 768px)": {
      paddingTop: "6px",
    },
  },
  numberFormat: {
    width: "134px !important",
    height: "39px !important",
    background: "none !important",
    borderRadius: "30px !important",
    border: "solid 1px #cccccc !important",
    fontSize: "14px !important",
    color: "#555555 !important",
    fontFamily: "RobotoRegular, sans-serif !important",
    "@media (max-width: 768px)": {
      position: "absolute",
      top: "-36px",
      left: "125px",
      height: "44px !important",
    },
  },
  numberFormatB: {
    width: "134px !important",
    height: "39px !important",
    background: "none !important",
    borderRadius: "30px !important",
    border: "solid 1px #cccccc !important",
    fontSize: "14px !important",
    color: "#555555 !important",
    fontFamily: "RobotoRegular, sans-serif !important",
    "@media (max-width: 768px)": {
      position: "absolute",
      height: "44px !important",
    },
  },
  backRootDonationButton: {
    fontSize: "14px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.21",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#ffffff",
    width: "236px",
    height: "44px",
    borderRadius: "40px",
    border: "none",
    backgroundColor: theme.palette ? theme.palette.primary.main : "#000",
    "&:hover": {
      backgroundColor: theme.palette ? theme.palette.secondary.main : "#000",
    },
  },
  formControlAutocomplete: {
    paddingTop: "1.14em",
    "& .MuiFormLabel-root": {
      margin: "-0.3em",
    },
    "& .MuiAutocomplete-endAdornment": {
      top: "1.2em",
    },
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
    "& .MuiAutocomplete-root": {
      "@media (max-width: 768px)": {
        width: "100% !important",
      },
    },
  },
});

export const stylesAutocomplete = (theme) => ({
  inputRoot: {
    height: "4.4em",
    width: "29.1em",
    "& .MuiAutocomplete-input": {
      background: "none !important",
      marginTop: "-1.0em",
    },
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
  },
});

export const stylesSelect = (theme) => ({
  rootAutocomplete: {
    with: "100%",
  },
  inputAutocomplete: {
    background: "none !important;",
    color: "#555555 !important;",
  },
  rootAutocomplete: {
    "& .MuiIconButton-label": {
      color: "#ccc",
      paddingTop: "0.4em",
      marginRight: "-0.2em",
    },
  },
  inputRootAutocomplete: {
    height: "55px",
    paddingTop: "0px !important",
  },
  multiSelect: {
    height: "29px !important",
    paddingTop: "6px!important",
    backgroundColor: "#fff",
    paddingLeft: "10px",
    width: "254px !important",
    borderRadius: "20px",
    border: "solid 1px #cccccc",
    fontSize: "14px !important",
    "&:focus": {
      width: "290px",
      height: "44px",
      borderRadius: "20px",
      border: "solid 1px #cccccc",
      backgroundColor: "#ffffff",
      fontSize: "10px",
      "@media (max-width: 768px)": {
        width: "100% !important",
      },
    },
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
  },
  select: {
    backgroundColor: "#fff",
    paddingLeft: "10px",
    paddingTop: "8px",
    width: "254px !important",
    height: "21px !important",
    borderRadius: "20px",
    border: "solid 1px #cccccc",
    fontSize: "14px !important",
    paddingTop: "13px !important",
    "&:focus": {
      width: "290px",
      height: "44px",
      borderRadius: "20px",
      border: "solid 1px #cccccc",
      backgroundColor: "#ffffff",
      fontSize: "10px",
      "@media (max-width: 768px)": {
        width: "100% !important",
      },
    },
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
  },
  root: {
    width: "290px !important",
    height: "44px !important",
    borderRadius: "20px",
    border: "solid 1px #cccccc",
    backgroundColor: "#ffffff",
    fontSize: "10px",
    width: "53px",
    height: "15px",
    borderRadius: "20px",
    border: "solid 1px #cccccc",
    backgroundColor: "#ffffff",
    fontSize: "10px",
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
  },
  icon: {
    width: "22px !important",
    paddingRight: "6px !important",
    paddingTop: "5px !important",
    fontSize: "20px",
    color: "#cccccc",
  },
  rootLabel: {
    zIndex: "999",
    margin: "6px 11px",
    fontSize: "14px",
  },
});
